"use client";

import { Award, Lightbulb, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Features() {
  const {
    ref: col1Ref,
    isVisible: col1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: col2Ref,
    isVisible: col2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: col3Ref,
    isVisible: col3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const features = [{
    icon: Award,
    title: "Award-Winning Designs",
    description: "Transforming architectural visions into reality with precision, creativity, and timeless elegance."
  }, {
    icon: Lightbulb,
    title: "Innovative Solutions",
    description: "Pioneering sustainable design approaches that blend functionality with environmental responsibility."
  }, {
    icon: Users,
    title: "Client-Focused Approach",
    description: "Collaborating closely with clients to deliver spaces that exceed expectations and inspire daily living."
  }];
  return <section id="features" className="hidden bg-background py-16 px-4 sm:py-20 md:py-24 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-12">
          <div ref={col1Ref} data-index={0} className={`group flex flex-col items-start transition-all duration-[var(--duration-medium)] ${col1Visible ? "animate-fade-in-up" : "opacity-0"}`}>
            <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-lg bg-accent/10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02] group-hover:opacity-90">
              <Award className="h-8 w-8 text-[#a03223] transition-all duration-[var(--duration-medium)] group-hover:scale-[1.02]" />
            </div>
            <h3 className="mb-3 font-display text-2xl font-bold text-foreground">
              {features[0].title}
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              {features[0].description}
            </p>
          </div>

          <div ref={col2Ref} data-index={1} className={`group flex flex-col items-start transition-all duration-[var(--duration-medium)] ${col2Visible ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>
            <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-lg bg-accent/10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02] group-hover:opacity-90">
              <Lightbulb className="h-8 w-8 text-[#a03223] transition-all duration-[var(--duration-medium)] group-hover:scale-[1.02]" />
            </div>
            <h3 className="mb-3 font-display text-2xl font-bold text-foreground">
              {features[1].title}
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              {features[1].description}
            </p>
          </div>

          <div ref={col3Ref} data-index={2} className={`group flex flex-col items-start transition-all duration-[var(--duration-medium)] ${col3Visible ? "animate-fade-in-up-delay-200" : "opacity-0"}`}>
            <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-lg bg-accent/10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02] group-hover:opacity-90">
              <Users className="h-8 w-8 text-[#a03223] transition-all duration-[var(--duration-medium)] group-hover:scale-[1.02]" />
            </div>
            <h3 className="mb-3 font-display text-2xl font-bold text-foreground">
              {features[2].title}
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              {features[2].description}
            </p>
          </div>
        </div>
      </div>
    </section>;
}